export default __webpack_public_path__ + "images/rosabandet/circle-pink-blur.svg";